import { App } from '@capacitor/app';
import { Keyboard } from '@capacitor/keyboard';
import { PushNotifications } from '@capacitor/push-notifications';

import { DEVICE } from "./config";

// Push notifications events
if (DEVICE === 'ANDROID') {
    PushNotifications.addListener('registration', e => {
        window.dispatchEvent(new CustomEvent('capacitor:pushNotifications:registration', {
            detail: e
        }));
    });
    PushNotifications.addListener('registrationError', e => {
        window.dispatchEvent(new CustomEvent('capacitor:pushNotifications:registrationError', {
            detail: e
        }));
    });
    PushNotifications.addListener('pushNotificationActionPerformed', e => {
        window.dispatchEvent(new CustomEvent('capacitor:pushNotifications:actionPerformed', {
            detail: e
        }));
        window.__CAPACITOR_PUSH_NOTIFICATION_PERFORMED__ = e;
    });
    PushNotifications.addListener('pushNotificationReceived', e => {
        window.dispatchEvent(new CustomEvent('capacitor:pushNotifications:received', {
            detail: e
        }));
    });
}

// Back button events
if (DEVICE === 'ANDROID') {
  App.addListener('backButton', (e) => {
    window.dispatchEvent(new CustomEvent('capacitor:app:backButton', {
      detail: e
    }));
  });
}

// Keyboard events
if (DEVICE === 'ANDROID') {
  Keyboard.addListener('keyboardDidShow', (e) => {
    window.dispatchEvent(new CustomEvent('capacitor:keyboard:show', {
      detail: e
    }));
  });
  Keyboard.addListener('keyboardDidHide', () => {
    window.dispatchEvent(new CustomEvent('capacitor:keyboard:hide'));
  });
}

// Dynamic safe area insets for Android
if (DEVICE === 'ANDROID') {
  (() => {
    const applyInsets = (insets) => {
      document.documentElement.style.setProperty('--safe-area-inset-top', `${insets?.top || 0}px`);
      document.documentElement.style.setProperty('--safe-area-inset-bottom', `${insets?.bottom || 0}px`);
      document.documentElement.style.setProperty('--safe-area-inset-left', `${insets?.left || 0}px`);
      document.documentElement.style.setProperty('--safe-area-inset-right', `${insets?.right || 0}px`);
    }

    let androidInsets = null;
    applyInsets(window.__ANDROID_INSETS__ || {});
    Object.defineProperty(window, '__ANDROID_INSETS__', {
      get() {
        return androidInsets;
      },
      set(value) {
        applyInsets(value)
        androidInsets = value;
      },
      configurable: true,
    });
  })();
}
